import { LeaderboardStore } from '@app/api/leaderboard.store';
import { apiResponse } from '@stores';
import { useQuery } from '@tanstack/react-query';
import { LeaderView, ParticipantView } from '@views';
import { ViewCreatorStaleTime } from '@utils/queryCacheConfig';

export class LeaderboardViewCreator {
  constructor(private readonly store: LeaderboardStore = new LeaderboardStore()) {}

  async createView(groupId: number) {
    const leaderboard = await apiResponse.handleApiResponse(() => this.store.readByCohortId(groupId));

    const view = Object.keys(leaderboard)
      .filter((rank) => {
        return leaderboard[Number(rank)].participant.isActive;
      })
      .map((rank) => {
        const leader = leaderboard[Number(rank)];
        const cohortUser = leader.participant;
        const user = cohortUser?.user;
        const participant = {
          name: user?.name,
          role: cohortUser?.role,
          avatarUrl: user?.avatarUrl,
          email: user?.email,
          id: user?.id,
          CohortUser: { id: cohortUser?.id },
        } as ParticipantView;
        return {
          [Number(rank)]: {
            participant: participant,
            successfulWeeks: leader.successfulWeeks,
            currentStreak: leader.currentStreak,
          },
        };
      })
      .reduce((view, item) => {
        const rank = Number(Object.keys(item)[0]);
        view[rank] = item[rank];
        return view;
      }, {} as LeaderView);
    return view;
  }
}

export const useLeaderboardViewCreator = (groupId: number) =>
  useQuery({
    queryKey: [LeaderboardViewCreator.name, groupId],
    queryFn: () => new LeaderboardViewCreator().createView(groupId),
    staleTime: ViewCreatorStaleTime.LeaderboardViewCreator,
  });
